import { Link } from 'react-router-dom';
import type { EventWithVenue } from './types';

const PinIcon = () => (
  <svg
    className="w-5 h-5 mr-3 mt-0.5 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
);

interface EventWhereSectionProps {
  event: EventWithVenue;
  venueIdString: string | undefined;
}

/**
 * Renders the venue-backed "Where" section, or the free-form "Location"
 * section for standalone events with no venue. Nothing when the event has
 * neither.
 */
export const EventWhereSection = ({ event, venueIdString }: EventWhereSectionProps) => {
  if (event.venueId) {
    return (
      <div>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">Where</h2>
        <div className="flex items-start">
          <PinIcon />
          <div>
            <Link
              to={`/wineries/${venueIdString}`}
              className="font-medium text-primary-600 hover:text-primary-700 hover:underline"
            >
              {event.venue?.name || 'View Venue'}
            </Link>
            {event.venue?.address && (
              <div className="text-sm text-gray-600 mt-1">
                {event.venue.address.city && event.venue.address.state && (
                  <span>
                    {event.venue.address.city}, {event.venue.address.state}
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (!event.location) return null;

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-3">Location</h2>
      <div className="flex items-start">
        <PinIcon />
        <div>
          {event.location.name && (
            <div className="font-medium text-gray-900">{event.location.name}</div>
          )}
          {event.location.address && (
            <div className="text-sm text-gray-600 mt-1">
              {event.location.address.street && (
                <div>{event.location.address.street}</div>
              )}
              {(event.location.address.city || event.location.address.state) && (
                <div>
                  {event.location.address.city}
                  {event.location.address.city && event.location.address.state && ', '}
                  {event.location.address.state} {event.location.address.zipCode}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
